import { TeamListItem, UserStatuses } from '../types';
import { UserRole } from '@modules/core/types';

export const NON_ADMIN_GROUP_NAME_SUBSTRING = ':non-administrator';

const adminLabel = 'Administrator';
const executiveLabel = 'Executive';
const memberLabel = 'Member';
const memberLimitedPHILabel = 'Member - Limited PHI';

export const USER_ROLES = [
  {
    id: UserRole.ADMINISTRATOR,
    label: adminLabel,
  },
  {
    id: UserRole.EXECUTIVE,
    label: executiveLabel,
  },
  {
    id: UserRole.MEMBER,
    label: memberLabel,
  },
  {
    id: UserRole.MEMBER_LIMITED_PHI,
    label: memberLimitedPHILabel,
  },
];

export const NON_ADMIN_USER_ROLES = USER_ROLES.filter((role) => role.id !== UserRole.ADMINISTRATOR);

export const MOCK_DATA: TeamListItem[] = [
  {
    id: '1',
    lastLogin: '2022-12-01T21:40:22.000Z',
    profile: {
      firstName: 'TestFirstName1',
      lastName: 'TestLastName1',
      email: 'test1@test.com',
      pp_role: 'MEMBER',
    },
    status: UserStatuses.ACTIVE,
  },
  {
    id: '2',
    lastLogin: null,
    profile: {
      firstName: 'TestFirstName2',
      lastName: 'TestLastName2',
      email: 'test2@test.com',
      pp_role: 'MEMBER',
    },
    status: UserStatuses.ACTIVE,
  },
  {
    id: '3',
    lastLogin: '2022-12-01T21:40:22.000Z',
    profile: {
      firstName: 'TestFirstName3',
      lastName: 'TestLastName3',
      email: 'test3@test.com',
      pp_role: 'MEMBER',
    },
    status: UserStatuses.ACTIVE,
  },
  {
    id: '4',
    lastLogin: '2022-12-01T21:40:22.000Z',
    profile: {
      firstName: 'TestFirstName4',
      lastName: 'TestLastName4',
      email: 'test4@test.com',
      pp_role: 'MEMBER',
    },
    status: UserStatuses.ACTIVE,
  },
  {
    id: '5',
    lastLogin: '2022-12-01T21:40:22.000Z',
    profile: {
      firstName: 'TestFirstName5',
      lastName: 'TestLastName5',
      email: 'test5@test.com',
      pp_role: 'MEMBER',
    },
    status: UserStatuses.ACTIVE,
  },
  {
    id: '6',
    lastLogin: '2022-12-01T21:40:22.000Z',
    profile: {
      firstName: 'TestFirstName6',
      lastName: 'TestLastName6',
      email: 'test6@test.com',
      pp_role: 'MEMBER',
    },
    status: UserStatuses.ACTIVE,
  },
  {
    id: '7',
    lastLogin: '2022-12-01T21:40:22.000Z',
    profile: {
      firstName: 'TestFirstName7',
      lastName: 'TestLastName7',
      email: 'test7@test.com',
      pp_role: 'MEMBER',
    },
    status: UserStatuses.ACTIVE,
  },
  {
    id: '8',
    lastLogin: '2022-12-01T21:40:22.000Z',
    profile: {
      firstName: 'TestFirstName8',
      lastName: 'TestLastName8',
      email: 'test8@test.com',
      pp_role: 'MEMBER',
    },
    status: UserStatuses.ACTIVE,
  },
  {
    id: '9',
    lastLogin: '2022-12-01T21:40:22.000Z',
    profile: {
      firstName: 'TestFirstName9',
      lastName: 'TestLastName9',
      email: 'test9@test.com',
      pp_role: 'MEMBER',
    },
    status: UserStatuses.DEPROVISIONED,
  },
  {
    id: '10',
    lastLogin: '2022-12-01T21:40:22.000Z',
    profile: {
      firstName: 'TestFirstName10',
      lastName: 'TestLastName10',
      email: 'test10@test.com',
      pp_role: 'MEMBER',
    },
    status: UserStatuses.ACTIVE,
  },
  {
    id: '11',
    lastLogin: '2022-12-01T21:40:22.000Z',
    profile: {
      firstName: 'TestFirstName11',
      lastName: 'TestLastName11',
      email: 'test11@test.com',
      pp_role: 'MEMBER',
    },
    status: UserStatuses.PROVISIONED,
  },
  {
    id: '12',
    lastLogin: '2022-12-01T21:40:22.000Z',
    profile: {
      firstName: 'TestFirstName12',
      lastName: 'TestLastName12',
      email: 'test12@test.com',
      pp_role: 'MEMBER',
    },
    status: UserStatuses.DEPROVISIONED,
  },
  {
    id: '13',
    lastLogin: '2022-12-01T21:40:22.000Z',
    profile: {
      firstName: 'TestFirstName13',
      lastName: 'TestLastName13',
      email: 'test13@test.com',
      pp_role: 'MEMBER',
    },
    status: UserStatuses.ACTIVE,
  },
  {
    id: '14',
    lastLogin: '2022-12-01T21:40:22.000Z',
    profile: {
      firstName: 'TestFirstName14',
      lastName: 'TestLastName14',
      email: 'test14@test.com',
      pp_role: 'MEMBER',
    },
    status: UserStatuses.ACTIVE,
  },
  {
    id: '15',
    lastLogin: '2022-12-01T21:40:22.000Z',
    profile: {
      firstName: 'TestFirstName15',
      lastName: 'TestLastName15',
      email: 'test15@test.com',
      pp_role: 'MEMBER',
    },
    status: UserStatuses.PROVISIONED,
  },
];

export const CURRENT_USER_QUERY_KEY = 'current-user';
export const TEAMS_QUERY_KEY = 'teams';
export const TEAMS_TRANSLATION = 'teams';

export const ADD_USER_ERROR_CODES = {
  USER_EXISTS: 'E0000001',
};
